import * as React from 'react';
import MaterialUIBadge, { BadgeProps } from '@material-ui/core/Badge';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const styles = {
  dot: {
    height: 12,
    width: 12,
    borderRadius: 8
  }
};

type Props = WithStyles<typeof styles> & Partial<BadgeProps>;

const BadgeComponent: React.FC<Props> = ({ classes, children, color = 'error' }) => {
  const { t } = useTranslation();
  return (
    <MaterialUIBadge
      children={children}
      classes={{
        dot: classes.dot
      }}
      color={color}
      variant="dot"
      title={t('components.dotBadge.thisSectionRequiresAction', 'This section requires action')}
    />
  );
};

export const DotBadge = withStyles(styles)(BadgeComponent);
